import HomeTemplate from '../templates/HomeTemplate.jsx'
import { SITE_NAME, SITE_URL } from '../utils/seo.js'

const title = `Extract Audio from Video Online – ${SITE_NAME}`
const description = 'Extract audio from any video URL instantly. Paste a YouTube, TikTok, Instagram or Facebook link and download the audio as MP3 in up to 320 kbps — free, no software needed.'
const canonical = `${SITE_URL}/extract-audio`

export default function ExtractAudio() {
  return (
    <HomeTemplate
      provider="generic"
      title={title}
      description={description}
      canonical={canonical}
      badge="Audio Extractor"
      heading={
        <>
          Extract Audio from{' '}
          <span className="text-gradient">Any Video</span>
        </>
      }
      subheading="Paste a video URL and extract the audio track as a high-quality MP3. Supports YouTube, TikTok, Instagram, and Facebook. Free, instant, no signup."
    />
  )
}
